import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconUsb: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"usb, connection, connect, save, data"} maskId="square-filled-radius-0-stroke-1-IconUsb"><path d="M10.5 8V5H9.5V8H10.5Z" fill="currentColor"/><path d="M14.5 5V8H13.5V5H14.5Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M19 2H5V10H3V22H21V10H19V2ZM18 10V3H6V10H18Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconUsb;
